
import Vue from 'vue'
import { Store } from '@/pages/categories/store'
import TheSidebar from '@/pages/categories/TheSidebar.vue'
import { MaxQuantityPrice } from '@/types/maxQuantityPrice'

export default Vue.extend({
  components: {
    TheSidebar
  },
  props: {
    sharedStore: {
      type: Object as () => Store,
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data() {
    return {
      store: this.sharedStore
    }
  },
  created() {
    this.store.getSidebarData()
  }
})
